import { render, staticRenderFns } from "./IP_ChecklistSummaryPrintable.vue?vue&type=template&id=48a7dc2c&scoped=true&"
import script from "./IP_ChecklistSummaryPrintable.vue?vue&type=script&lang=js&"
export * from "./IP_ChecklistSummaryPrintable.vue?vue&type=script&lang=js&"
import style0 from "./IP_ChecklistSummaryPrintable.vue?vue&type=style&index=0&id=48a7dc2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a7dc2c",
  null
  
)

export default component.exports